import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { RutaPrivada } from './features/auth/RutaPrivada.js';
import { SessionProvider } from './features/auth/session.js';
import { Acceso } from './pages/Acceso.js';
import { Dashboard } from './pages/Dashboard.js';
import { Ajustes } from './pages/Ajustes.js';
import { Biblioteca } from './pages/Biblioteca.js';
import { Estado } from './pages/Estado.js';
import { Identidades } from './pages/Identidades.js';
import { NuevoProyecto } from './pages/NuevoProyecto.js';
import { Proyecto } from './pages/Proyecto.js';

export function App(): React.JSX.Element {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/entrar" element={<Acceso modo="entrar" />} />
            <Route path="/registro" element={<Acceso modo="registro" />} />
            <Route
              path="/"
              element={
                <RutaPrivada>
                  <Dashboard />
                </RutaPrivada>
              }
            />
            <Route
              path="/proyectos/nuevo"
              element={
                <RutaPrivada>
                  <NuevoProyecto />
                </RutaPrivada>
              }
            />
            <Route
              path="/proyectos/:id"
              element={
                <RutaPrivada>
                  <Proyecto />
                </RutaPrivada>
              }
            />
            <Route
              path="/biblioteca"
              element={
                <RutaPrivada>
                  <Biblioteca />
                </RutaPrivada>
              }
            />
            <Route
              path="/ajustes"
              element={
                <RutaPrivada>
                  <Ajustes />
                </RutaPrivada>
              }
            />
            <Route
              path="/identidades"
              element={
                <RutaPrivada>
                  <Identidades />
                </RutaPrivada>
              }
            />
            <Route
              path="/estado"
              element={
                <RutaPrivada>
                  <Estado />
                </RutaPrivada>
              }
            />
            <Route path="*" element={<p>Página no encontrada.</p>} />
          </Route>
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  );
}
